import React from 'react'

import Image from 'next/image'

import { Text } from 'Components/UI'
import { useSwiperSlide } from 'swiper/react'

import { Container, ImageHolder, TextHolder } from './styles'

import { LearnSectionGalleryItem } from '../../constants'

type Props = {
  item?: LearnSectionGalleryItem
}

function LearnSectionGalleryCarouselSlide({ item }: Props) {
  const swiperSlide = useSwiperSlide()

  const isActive = swiperSlide.isActive

  if (!item) return null

  return (
    <Container
      animate={{
        opacity: isActive ? 1 : 0.4,
        scale: isActive ? 1 : 0.65,
        filter: isActive ? 'saturate(1)' : 'saturate(0)',
      }}
    >
      <ImageHolder>
        <Image
          alt={item.name + ' ' + item.caption}
          height={item.image.height}
          src={item.image.src}
          width={item.image.width}
        />
      </ImageHolder>

      <TextHolder
        style={{
          scale: isActive ? 1 : 0.8,
          opacity: isActive ? 1 : 0,
        }}
      >
        <Text body bold center mt={3} nowrap screen14>
          {item.name}
        </Text>

        <Text accent center preWrap regular screen14>
          {item.caption}
        </Text>
      </TextHolder>
    </Container>
  )
}

export default LearnSectionGalleryCarouselSlide
